/**
 * Auth configuration.
 *
 * VITE_AUTH_ENABLED=false (default): No Auth0 SDK loaded, zero network calls
 * VITE_AUTH_ENABLED=true: Full Auth0 PKCE flow
 */

export const AUTH_ENABLED = import.meta.env.VITE_AUTH_ENABLED === 'true'

export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || 'dev-b3lm8zm852r4gg5a.us.auth0.com',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || 'Oq1CpSsfIObxETYIko2GdN1mvwTPWBpR',
  audience: import.meta.env.VITE_AUTH0_AUDIENCE || 'https://api.pixsift.com',
  redirectUri: window.location.origin,
}
